import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import "./styles/App.css";

// Import pages
import DispatchForm from "./pages/DispatchForm.jsx";
import DriverVerificationForm from "./pages/DriverVerificationForm.jsx";
import FormsDashboard from "./pages/FormsDashboard.jsx";
import GlobalDashboard from "./pages/GlobalDashboard.jsx";

import ErrorReport from "./pages/ErrorReport.jsx";
import FormErrors from "./pages/FormErrors.jsx";
import Responses from "./pages/Responses.jsx";
import CameraFallback from "./pages/CameraFallback.jsx";
import ErrorDistributionChart from "./components/ErrorDistributionChart.jsx";
import ThankYouPage from "./pages/ThankYouPage.jsx";

function App() {
   return (
      <AuthProvider>
         <Router>
            <div className="App">
               <Routes>
                  {/* Set root to the global dashboard */}
                  <Route path="/" element={<GlobalDashboard />} />

                  {/* Dispatch routes */}
                  <Route path="/dispatch-form" element={<DispatchForm />} />
                  <Route path="/responses/dispatch" element={<Responses formType="dispatch" />} />

                  {/* Driver verification routes */}
                  <Route path="/driver-form" element={<DriverVerificationForm />} />
                  <Route
                     path="/driver-verification/responses"
                     element={<Responses formType="driver_verification" />}
                  />

                  {/* Forms dashboard routes */}
                  <Route path="/forms" element={<FormsDashboard />} />
                  <Route path="/forms/report/:formId" element={<ErrorReport />} />
                  <Route path="/forms/:formId/errors" element={<FormErrors />} />

                  {/* Global dashboard (also available at /dashboard) */}
                  <Route path="/dashboard" element={<GlobalDashboard />} />

                  {/* [TO-DO]: See with caleb the need for this component */}
                  {/* Camera fallback */}
                  <Route path="/camera-fallback" element={<CameraFallback />} />

                  {/* Thank you page */}
                  <Route path="/thank-you" element={<ThankYouPage />} />

                  {/* New routes */}
                  <Route
                     path="/dashboard/error-distribution"
                     element={<ErrorDistributionChart />}
                  />
               </Routes>
            </div>
         </Router>
      </AuthProvider>
   );
}

export default App;
